// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-layout[data-v-fae5bece] {\n  background: white;\n}", ""]);
// Exports
module.exports = exports;
